/* enemy-wholesale.js — detección wholesale server-side via body class */
(function () {
  'use strict';
  /* La clase wholesale-mode ya viene aplicada desde theme.liquid via Liquid.
     Este script maneja comportamientos adicionales client-side. */
  const isWholesale = document.body.classList.contains('wholesale-mode');

  document.addEventListener('DOMContentLoaded', () => {
    if (!isWholesale) return;

    /* Verificar pedido mínimo en formularios de producto */
    document.querySelectorAll('[data-wholesale-min]').forEach(input => {
      const min = parseInt(input.dataset.wholesaleMin, 10) || 3;
      if (parseInt(input.value, 10) < min) input.value = min;
      input.min = min;
    });

    /* Actualizar badge en header si existe */
    document.querySelectorAll('.ec-wholesale-badge').forEach(el => {
      el.style.display = 'flex';
    });
  });
})();
